<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Bread Request Form
        <div class="card-header-actions">
          <button
            v-if="saveEnabled"
            class="btn btn-primary mr-1"
            @click="save()"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <button
            class="btn btn-success mr-1"
            @click="exportXlsx()"
            type="button"
          >
            <i class="fa fa-file-excel-o"></i> Export XLSX
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-form>
        <b-row>
          <b-col md="3">
            <b-input-group>
              <b-input-group-append
                ><span class="input-group-text"
                  >Request Date</span
                ></b-input-group-append
              >
              <b-form-input
                v-model="model.orderdate"
                type="date"
                @change="tanggalBerubah"
                :state="!$v.model.orderdate.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col md="3">
            <b-input-group>
              <!-- dibawah ini feature untuk memilih customer wholesale / retail -->
              <b-input-group-prepend v-if="!isEdit"
                ><label v-on:click.ctrl="generateQtyCustomer">Customer Group</label></b-input-group-prepend
              >
              <b-form-select
                v-model="model.customer_group"
                :options="custgroup"
                @change="reloaddata"
                v-if="!isEdit"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col md="3">
             <b-input-group class="p-2">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                    <b> {{ filterShow }}</b> Filter
                </b-form-checkbox>
             </b-input-group>
          </b-col>
        </b-row>
        <b-card no-body class="mb-1">
           <b-row v-if="(filterShow=='Hide')" class="mt-2">
              <b-col lg="4">
                  <b-form-group
                      label="Filter"
                      label-cols-sm="1"
                      label-size="sm"
                      label-for="filterInput"
                      class="mb-0"
                      >
                      <b-input-group size="sm">
                          <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                          ></b-form-input>
                          <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                          </b-input-group-append>
                      </b-input-group>
                  </b-form-group>  
              </b-col> 
              <b-col lg="5">
                <b-form-group
                  label="Filter On"
                  label-cols-sm="1"
                  label-size="sm"
                  description="Leave all unchecked to filter on all data"
                  class="mb-0">
                  <b-form-checkbox-group v-model="filterOn" class="mt-1">
                    <b-form-checkbox value="itemname">Item Name</b-form-checkbox>
                    <b-form-checkbox value="vendor">Last Vendor</b-form-checkbox>
                    <!-- <b-form-checkbox value="createby">Issued By</b-form-checkbox> -->
                    <!-- <b-form-checkbox value="crewname">Employee Name</b-form-checkbox> -->
                  </b-form-checkbox-group>
                </b-form-group>                
              </b-col>                 
              <b-col lg="3">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                        <b> {{ filterShow }}</b> Filter
                      </b-form-checkbox>
              </b-col>         
          </b-row>
          <b-table-simple hover small responsive bordered sticky-header="500px">
            <b-thead head-variant="light">
              <b-tr>
                <b-th sticky-column style="min-width: 295px" variant="light"
                  >Item</b-th
                >
                <b-th
                  width="50px"
                  v-for="kol in customers"
                  :key="kol.CustCode"
                  >{{ kol.CustName }}</b-th
                >
                <b-th style="text-align: right" width="80px" variant="success"
                  >TOTAL QTY REQUEST</b-th
                >
                <!-- <b-th style="text-align: right" width="100px" variant="success"
                  >Purc.Price</b-th
                >
                <b-th style="text-align: right" width="100px" variant="success"
                  >Amount</b-th
                > -->
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(row, idx) in ordLines.items" :key="row.itemno" :id="row.itemno">
                <b-th sticky-column>
                  <div style="display: inline-block; width: 295px">
                    <div style="width: 215px; font-weight: normal !important">
                      {{ idx + 1 }}. {{ row.itemname }}
                    </div>
                    <div
                      style="
                        float: right;
                        margin-top: -20px;
                        width: 80px;
                        text-align: right;
                        font-size: smaller;
                        font-weight: normal !important;
                      "
                    >
                      TOTAL QTY REQUEST: {{ row.quantity | numFormat }}
                    </div>

                  </div>
                </b-th>
                <b-td
                  v-for="kol in customers"
                  :key="kol.CustCode"
                  style="padding: 0 !important"
                >
                  <input
                    type="number"
                    style="width: 100%; border: none"
                    :min="0"
                    v-model="row[`K${kol.CustCode}`]"
                    @change="calcTotQty(row)"
                    :key="`${row.podtlkey}${kol.CustCode}`"
                  />
                </b-td>
                <b-td style="text-align: right" variant="success">
                  {{ row.quantity | numFormat }}
                </b-td>
               
              </b-tr>
            </b-tbody>
            <b-tfoot>
              <b-tr>
                <b-th sticky-column style="min-width: 295px" variant="light"
                  >Total</b-th
                >
                <b-th
                  width="50px"
                  v-for="kol in customers"
                  :key="kol.CustCode"
                  class="text-right"
                  >{{ footLines[kol.CustCode] }}</b-th
                >
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </b-card>


        <b-row align-h="between" class="mt-1">
          <b-col offset="8" lg="4">
              <div class="text-right">
                  <b-input-group >
                      <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Qty Total</label></b-input-group-prepend>
                      <b-input-group-prepend>
                      </b-input-group-prepend>
                      <my-number class="form-control text-right" v-model="model.ttlqty" disabled></my-number>
                  </b-input-group>
              </div>
          </b-col>
      </b-row>


      </b-form>
      <b-row class="justify-content-center mt-1">
        <div style="width: 420px">
          <b-input-group>
            <b-input-group-append>
              <button
                v-if="saveEnabled"
                class="btn btn-primary mr-1"
                @click="save()"
              >
                <i class="fa fa-save"></i> Save
              </button>
            </b-input-group-append>
            <b-input-group-append>
              <button
                class="btn btn-success mr-1"
                @click="exportXlsx()"
                type="button"
              >
                <i class="fa fa-file-excel-o"></i> Export XLSX
              </button>
            </b-input-group-append>
            <b-input-group-append>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import ExcelJS from "exceljs";
import myNumber from "../../components/my-number";
import procure from "../../apis/bakeryorder";
import customer from "../../apis/bakerycustomer";
import { validationMixin } from "vuelidate";
import { required, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      orderdate: { required },
      matauang: { required },
    },
  },
  data() {
    return {
      filterShow:'Hide',
      filter: '',
      filterOn: [],
      saveEnabled: true,
      isLoading: false,
      isEdit: false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lkuVendorShow: false,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      calcVAT: 1,
      calcuationVAT: [
        { value: 1, text: "VAT (Auto Calc)" },
        { value: 0, text: "VAT (Manual Calc)" },
      ],
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" },
      ],
      lookupPPH: [],
      customers: [],
      items: [],
      itemprice: [],
      ordLines: {
        items: [],
      },
      footLines: [],
      custgroup: [{ value: "", text: "-- ALL--" }],
      model: {
        jasa: 0,
        orderdate: moment().format("YYYY-MM-DD"),
        requestno: "",
        ExpectRcv: "",
        remark: "",
        postgroup: "",
        typegroup: "OPEX",
        matauang: this.$store.state.user.matauang,
        compcode: this.$store.state.user.compcode,
        invterm: "COD",
        kodecash: "",
        terms: [],
        locationdeliv: this.$store.state.user.compaddr,
        ttlnetto: 0,
        nilaippn: 0,
        ttlamtdue: 0,
        ttlqty:0,
        customer_group: "",
        sortBy: "partnumber"
      },
      tabIndex: 0,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function () {
    if (this.$route.params.tgldelivery) {
      toastr.info("Loading Order Detail, please wait");
      try {
        this.model.customer_group = this.$route.params.customer_group;
        this.isEdit = true;
        this.isLoading = true;
        const [a, b, data, custgroup] = await Promise.all(
          [
            // procure.customeraktif(this.$route.params),
            procure.customerdistributionaktif(this.$route.params),
            procure.itemaktif(this.model),
            procure.detailrequest(this.$route.params),
            customer.group()
          ],
        );
        this.model.orderdate = moment(this.$route.params.tgldelivery).format("YYYY-MM-DD");
        this.customers = a;
        this.items = b;
        if (custgroup) {
          custgroup.map((data) => {
            this.custgroup.push({
              value: data.value,
              text: data.text,
            });
          });
        }

        const customerCodes = new Set(this.customers.map((c) => c.CustCode));

        this.model.ttlqty = 0;
        let obj;
        this.items.forEach((item) => {
          obj = {
            itemno: item.itemno,
            partnumber: item.partnumber,
            itemname: item.itemname,
            unitsize: item.unitsize,
            unitprice: item.unitcost,
            saleprice: item.unitprice,
            quantity: 0,
            ttlnetto: 0,
            nilaippn: 0,
            ttlamtdue: 0,
            disc: 0,
            vendor: item.vendor || ""
          };
          this.ordLines.items.push(obj);
        });

        const row = data[0] || {};
        row.tgldelivery = row.tgldelivery
          ? moment(row.tgldelivery).format("YYYY-MM-DD")
          : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        if (row.tgldelivery < this.$store.state.user.tglaktif) {
          this.saveEnabled = false;
        }

        // Populate customer qty only for active customers present in this.customers
        for (let index = 0; index < data.length; index++) {
          const item = data[index];
          if (customerCodes.has(item.CustCode)) {
            let findIdx_ = this.ordLines.items.findIndex((x) => x.itemno == item.itemno);
            if (findIdx_ > -1) {
              this.ordLines.items[findIdx_][`K${item.CustCode}`] = item.qtyOrder;
            }
          }
        }

        // Recalculate row quantity exactly as the sum of customer quantities in this.customers
        this.ordLines.items.forEach((itemRow) => {
          let rowQty = 0;
          this.customers.forEach((kol) => {
            rowQty += parseFloat(itemRow[`K${kol.CustCode}`] || 0);
          });
          itemRow.quantity = rowQty;
        });

        this.ordLines.total = this.ordLines.items.length;
        this.calcTotalDtlOrder();
        this.calcFootLines();
        toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.isLoading = true;
      this.model.orderdate = moment().format("YYYY-MM-DD");
      const [a, b, custgroup] = await Promise.all([
        //procure.customeraktif(),
        procure.customerdistributionaktif(this.model),
        procure.itemaktif(this.model),
        customer.group(),
      ]);
      this.customers = a;
      this.items = b;
      if (custgroup) {
        custgroup.map((data) => {
          this.custgroup.push({
            value: data.value,
            text: data.text,
          });
        });
      }

      let obj;
      this.items.forEach((item) => {
        obj = {
          itemno: item.itemno,
          partnumber: item.partnumber,
          itemname: item.itemname,
          unitsize: item.unitsize,
          unitprice: item.unitcost,
          saleprice: item.unitprice,
          quantity: 0,
          ttlnetto: 0,
          nilaippn: 0,
          ttlamtdue: 0,
          disc: 0,
          vendor:item.vendor||''
          // ,
          // createby:item.createby||''
        };
        this.ordLines.items.push(obj);
      });
      // this.ordLines.items=b;
      this.ordLines.total = b.length;
      this.isLoading = false;
      let footLines = [];
      a.map((data) => {
        footLines[data.CustCode] = 0;
      });
      this.footLines = footLines;
    }
  },
  watch:{
    filterShow(val){
      console.log('filterShow',val);
    },
    filterOn (val){
      console.log('filterOn',val);
      this.onFiltered(this.filter)
    },
    filter(val){
      console.log('filter',val);
      this.onFiltered(val)
    },
  },
  methods: {
    generateQtyCustomer: function(){
        toastr.info('generate Customer Qty Order randomly');
            let obj;
            let orderprice;
            this.ordLines.items.forEach((item)=> {
                orderprice= this.itemprice.find(ip=>ip.itemno=item.itemno);
                if (orderprice) {
                    item.unitprice=orderprice.unitprice;
                }
                this.customers.forEach((kol)=> {
                    item[`K${kol.CustCode}`]=Math.floor(Math.random() * 11); 
                    item.quantity += item[`K${kol.CustCode}`];
                })

                this.calcPrice(item);
            });
            this.calcTotalDtlOrder();
    },
    onFiltered(filtertext) {
      let items = this.ordLines.items;
      this.filterOn.map((filter)=>{
        let ttl=0;
        let sum_=0;
        let footItems = [];
        
        items.map((item)=>{
          var result_style = document.getElementById(item.itemno).style;
          if (item[filter].toUpperCase().indexOf(filtertext.toUpperCase()) > -1) {
            result_style.display = '';
            ttl += item.quantity || 0;
            footItems.push(item);
          }else{
            result_style.display = 'none';
          }
        });
        this.model.ttlqty = ttl;

        let footLines = [];
        this.customers.map((data) => {
            const dtfilter = footItems.filter(x=>x[`K${data.CustCode}`]>0);
            const sum_ = dtfilter.reduce((ttl=0,dt)=>{
                ttl +=dt[`K${data.CustCode}`];
                return ttl;
            },0);
            footLines[data.CustCode] = sum_;
        });
        this.footLines = footLines;
      });
    },
    async reloaddata() {
      this.items = [];
      this.ordLines.items = [];
      this.isLoading = true;
      this.model.orderdate = moment(this.model.orderdate).format("YYYY-MM-DD");
      const [a, b] = await Promise.all([
        // procure.customeraktif(this.model),
        procure.customerdistributionaktif(this.model),
        procure.itemaktif(this.model),
      ]);
      this.customers = a;
      this.items = b;
      this.model.ttlqty = 0;
      let obj;
      this.items.forEach((item) => {
        obj = {
          itemno: item.itemno,
          partnumber: item.partnumber,
          itemname: item.itemname,
          unitsize: item.unitsize,
          unitprice: item.unitcost,
          saleprice: item.unitprice,
          quantity: 0,
          ttlnetto: 0,
          nilaippn: 0,
          ttlamtdue: 0,
          disc: 0,
          vendor:item.vendor||''
          // ,
          // createby:item.createby||''
        };
        this.ordLines.items.push(obj);
      });
      // this.ordLines.items=b;
      this.ordLines.total = b.length;
      this.isLoading = false;
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.isLoading = true;
          this.model.TableName = "po_header";

          // this.model.DimTableKey = diisi dari PR/SR;
          this.model.pohdrkey = this.model.pohdrkey || "";
          this.model.orderno = this.model.orderno || "";
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.terms = this.model.terms;
          row.orderdate = moment(row.orderdate).format("YYYY-MM-DD");
          row.expectreceipt = row.expectreceipt
            ? moment(row.expectreceipt).format("YYYY-MM-DD")
            : undefined;
          let lineno = 1;
          row.lines = this.ordLines.items.reduce((newArr, item) => {
            if ((item.itemno || "") != "") {
              item.lineno = lineno;
              newArr.push(item);
              lineno += 1;
            }
            return newArr;
          }, []);
          if (row.lines.length > 0) {
            await procure.saverequest(row);
            this.isLoading = false;
            toastr.success(`Success`, "Save Request Order", 10000);
            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.saveEnabled = true;
              const tanggal = this.model.orderdate;
              this.model.ttlamtdue = 0;
              this.model.ttlnetto = 0;
              this.model.nilaippn = 0;
              const keys = ["ttlamtdue", "ttlnetto", "nilaippn"];
              for (var key in this.model) {
                if (keys.indexOf(key) == -1) {
                  this.model[key] = "";
                }
              }
              this.model.orderdate = tanggal;
              this.ordLines.items = [];
              this.ordLines.total = this.ordLines.items.length;
              this.calcTotalDtlOrder();
              this.$v.model.$reset();
            }
          } else {
            toastr.error(
              "Please fill at least 1(one) Order Detail",
              "ERROR MESSAGE"
            );
            this.saveEnabled = true;
            this.isLoading = false;
          }
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },

    calcFootLines(){
        let footLines = [];
        let ordLinesItem = this.ordLines.items;
            this.customers.map((data) => {
                const dtfilter = ordLinesItem.filter(x=>x[`K${data.CustCode}`]>0);
                const sum_ = dtfilter.reduce((ttl=0,dt)=>{
                    ttl +=dt[`K${data.CustCode}`];
                    return ttl;
                },0);
                footLines[data.CustCode] = sum_;
            });
            this.footLines = footLines;
    },

    calcTotQty: function (record) {
      setTimeout(() => {
        record.quantity = 0;
        this.customers.forEach((kol) => {
          record.quantity += parseFloat(record[`K${kol.CustCode}`] || 0);
        this.footLines[`${kol.CustCode}`] = this.ordLines.items.reduce(
          (ttl = 0, data) => {
            ttl += parseFloat(data[`K${kol.CustCode}`] ||0);
            return ttl;
          },
          0
        );
        });

        this.calcPrice(record);
        this.calcTotalDtlOrder();
      }, 100);
    },
    calcTotalDtlOrder: function () {
      this.calcVAT = this.calcVAT || 1;
      let nilaippn = 0;
      let ttlnetto = 0;
      let ttlqty = 0;
      let ttlamtdue = 0;
      // let totalpph = 0;
      let footLines_ = this.footLines;
      this.ordLines.items.forEach(function (trx) {
        if (trx.itemno) {
          ttlnetto += trx.nilai || 0;
          ttlqty += (trx.quantity || 0);
          nilaippn += trx.nilaippn || 0;
          ttlamtdue = ttlnetto + (nilaippn || 0);
          // totalpph += parseFloat(trx.nilaipph || 0);
        }
      });
      this.model.ttlnetto = ttlnetto;
      this.model.ttlqty = ttlqty;
      if (this.calcVAT == 1) {
        this.model.nilaippn = nilaippn;
      }
      this.model.ttlamtdue = ttlamtdue;
      // this.model.totalpph = totalpph;
      this.footLines = footLines_;
    },
    calcAmountDue: function () {
      this.model.ttlamtdue =
        parseFloat(this.model.ttlnetto || 0) +
        parseFloat(this.model.nilaippn || 0);
    },
    calcTaxes: function (record) {
      record.nilainett =
        parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
      record.dpp =
        (parseFloat(record.nilai) * parseFloat(record.dppnlain)) / 100;
      if (record.kenappn == 1) {
        record.ppn = record.ppn || 11;
      } else {
        // if ((record.ppn || 0) == 0 ) {
        // record.kenappn = 0;
        record.dpp = 0;
        record.ppn = 0;
      }
      // if (this.model.grossup == 1)
      //     record.dpp = record.dpp * (100 / (100 - record.pph));

      record.nilaippn = (parseFloat(record.ppn) / 100) * record.dpp;
      record.nilaidue = record.nilainett + record.nilaippn;
    },

    calcPrice: function (record) {
      // setTimeout(() => {
      record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
      record.disc = record.disc ? record.disc : 0;
      if (record.disc > 0) {
        record.nilaidisc = (record.disc * record.nilai) / 100.0;
      }
      // }, 100);
      // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
      this.calcTaxes(record);
    },
    calcPriceDelay: function (record) {
      const this_ = this;
      setTimeout(() => {
        record.nilai =
          parseFloat(record.quantity) * parseFloat(record.unitprice);
        if (record.disc > 0) {
          record.nilaidisc = (record.disc * record.nilai) / 100.0;
        }
        this_.calcTotalDtlOrder();
      }, 100);
    },
    
    async tanggalBerubah() {
      this.isLoading = true;
      this.tahun = moment(this.model.orderdate).format("YYYY");
      const [a] = await Promise.all([procure.customerdistributionaktif(this.model)]);
      this.customers = a;
      this.ordLines.items.forEach((itemRow) => {
        let rowQty = 0;
        this.customers.forEach((kol) => {
          rowQty += parseFloat(itemRow[`K${kol.CustCode}`] || 0);
        });
        itemRow.quantity = rowQty;
      });
      this.calcFootLines();
      this.calcTotalDtlOrder();
      this.isLoading = false;
    },

    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "bakery.requestfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push("home");
      }
    },

    async exportXlsx() {
      if (!this.ordLines || !this.ordLines.items || this.ordLines.items.length === 0) {
        toastr.warn("Tidak ada data untuk diexport", "EXPORT XLSX");
        return;
      }
      this.isLoading = true;
      try {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = "CK Bakery";
        workbook.created = new Date();

        const worksheet = workbook.addWorksheet("Bread Request", {
          views: [{ state: "frozen", xSplit: 1, ySplit: 6, showGridLines: true }]
        });

        // Styling definitions
        const thinBorder = {
          top: { style: "thin", color: { argb: "FFD0D5DD" } },
          left: { style: "thin", color: { argb: "FFD0D5DD" } },
          bottom: { style: "thin", color: { argb: "FFD0D5DD" } },
          right: { style: "thin", color: { argb: "FFD0D5DD" } }
        };

        const doubleBottomBorder = {
          top: { style: "thin", color: { argb: "FFD0D5DD" } },
          left: { style: "thin", color: { argb: "FFD0D5DD" } },
          bottom: { style: "double", color: { argb: "FF333333" } },
          right: { style: "thin", color: { argb: "FFD0D5DD" } }
        };

        const headerFill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF2F4F7" }
        };

        const headerFont = {
          name: "Segoe UI",
          size: 10,
          bold: true,
          color: { argb: "FF333333" }
        };

        const successHeaderFill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD4EDDA" }
        };

        const successHeaderFont = {
          name: "Segoe UI",
          size: 10,
          bold: true,
          color: { argb: "FF155724" }
        };

        const successCellFill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFEAF7EC" }
        };

        const successCellFont = {
          name: "Segoe UI",
          size: 10,
          bold: true,
          color: { argb: "FF155724" }
        };

        const regularFont = {
          name: "Segoe UI",
          size: 10,
          color: { argb: "FF212529" }
        };

        // Form Title & Information
        worksheet.getCell("A1").value = "BREAD REQUEST FORM";
        worksheet.getCell("A1").font = { name: "Segoe UI", size: 14, bold: true, color: { argb: "FF212529" } };
        worksheet.getRow(1).height = 24;

        worksheet.getCell("A3").value = "Request Date";
        worksheet.getCell("A3").font = { name: "Segoe UI", size: 10, bold: true };
        worksheet.getCell("B3").value = this.model.orderdate ? moment(this.model.orderdate).format("YYYY-MM-DD") : "-";
        worksheet.getCell("B3").font = regularFont;

        const groupObj = this.custgroup.find(g => g.value === this.model.customer_group);
        const groupName = groupObj ? groupObj.text : (this.model.customer_group || "-- ALL --");
        worksheet.getCell("A4").value = "Customer Group";
        worksheet.getCell("A4").font = { name: "Segoe UI", size: 10, bold: true };
        worksheet.getCell("B4").value = groupName;
        worksheet.getCell("B4").font = regularFont;

        // Table Header (Row 6)
        const headerRowNumber = 6;
        const headerRow = worksheet.getRow(headerRowNumber);
        headerRow.height = 28;

        // Column 1: Item
        const cellItem = headerRow.getCell(1);
        cellItem.value = "Item";
        cellItem.font = headerFont;
        cellItem.fill = headerFill;
        cellItem.alignment = { vertical: "middle", horizontal: "center" };
        cellItem.border = thinBorder;

        // Customer Columns
        const customers = this.customers || [];
        customers.forEach((kol, kIdx) => {
          const cell = headerRow.getCell(2 + kIdx);
          cell.value = kol.CustName;
          cell.font = headerFont;
          cell.fill = headerFill;
          cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
          cell.border = thinBorder;
        });

        // Total QTY REQUEST Column
        const totalColIndex = 2 + customers.length;
        const cellTotHeader = headerRow.getCell(totalColIndex);
        cellTotHeader.value = "TOTAL QTY REQUEST";
        cellTotHeader.font = successHeaderFont;
        cellTotHeader.fill = successHeaderFill;
        cellTotHeader.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        cellTotHeader.border = thinBorder;

        // Determine visible rows (respect active search filter if any)
        const visibleItems = this.ordLines.items.filter((item) => {
          const el = document.getElementById(item.itemno);
          return !el || el.style.display !== "none";
        });

        // Helper to convert column number to Excel column letter (e.g. 1 -> A, 2 -> B, 93 -> CO)
        const getColumnLetter = (colIdx) => {
          let letter = "";
          let temp = colIdx;
          while (temp > 0) {
            const mod = (temp - 1) % 26;
            letter = String.fromCharCode(65 + mod) + letter;
            temp = Math.floor((temp - mod) / 26);
          }
          return letter;
        };

        const firstCustColLetter = customers.length > 0 ? getColumnLetter(2) : "A";
        const lastCustColLetter = customers.length > 0 ? getColumnLetter(1 + customers.length) : "A";
        const totalColLetter = getColumnLetter(totalColIndex);

        // Data Rows
        const dataStartRow = 7;
        visibleItems.forEach((row, idx) => {
          const currentRowNumber = dataStartRow + idx;
          const dataRow = worksheet.getRow(currentRowNumber);
          dataRow.height = 20;

          // Item Name
          const cItem = dataRow.getCell(1);
          cItem.value = `${idx + 1}. ${row.itemname}`;
          cItem.font = regularFont;
          cItem.alignment = { vertical: "middle", horizontal: "left" };
          cItem.border = thinBorder;

          // Customer Quantities
          customers.forEach((kol, kIdx) => {
            const cCust = dataRow.getCell(2 + kIdx);
            const val = parseFloat(row[`K${kol.CustCode}`]) || 0;
            cCust.value = val;
            cCust.font = regularFont;
            cCust.numFmt = "#,##0";
            cCust.alignment = { vertical: "middle", horizontal: "right" };
            cCust.border = thinBorder;
          });

          // Total Qty Row: Use Excel SUM formula with evaluated result matching web
          const cTotal = dataRow.getCell(totalColIndex);
          const totalVal = customers.reduce((acc, kol) => acc + (parseFloat(row[`K${kol.CustCode}`]) || 0), 0);
          if (customers.length > 0) {
            cTotal.value = {
              formula: `SUM(${firstCustColLetter}${currentRowNumber}:${lastCustColLetter}${currentRowNumber})`,
              result: totalVal
            };
          } else {
            cTotal.value = totalVal;
          }
          cTotal.font = successCellFont;
          cTotal.fill = successCellFill;
          cTotal.numFmt = "#,##0";
          cTotal.alignment = { vertical: "middle", horizontal: "right" };
          cTotal.border = thinBorder;
        });

        // Table Footer (Total Row)
        const footerRowNumber = dataStartRow + visibleItems.length;
        const footerRow = worksheet.getRow(footerRowNumber);
        footerRow.height = 24;

        const footItemCell = footerRow.getCell(1);
        footItemCell.value = "Total";
        footItemCell.font = headerFont;
        footItemCell.fill = headerFill;
        footItemCell.alignment = { vertical: "middle", horizontal: "left" };
        footItemCell.border = doubleBottomBorder;

        customers.forEach((kol, kIdx) => {
          const colIdx = 2 + kIdx;
          const colLetter = getColumnLetter(colIdx);
          const footCustCell = footerRow.getCell(colIdx);
          const sumVal = visibleItems.reduce((acc, row) => acc + (parseFloat(row[`K${kol.CustCode}`]) || 0), 0);
          if (visibleItems.length > 0) {
            footCustCell.value = {
              formula: `SUM(${colLetter}${dataStartRow}:${colLetter}${footerRowNumber - 1})`,
              result: sumVal
            };
          } else {
            footCustCell.value = sumVal;
          }
          footCustCell.font = headerFont;
          footCustCell.fill = headerFill;
          footCustCell.numFmt = "#,##0";
          footCustCell.alignment = { vertical: "middle", horizontal: "right" };
          footCustCell.border = doubleBottomBorder;
        });

        const footTotalCell = footerRow.getCell(totalColIndex);
        const grandTotal = visibleItems.reduce((acc, row) => {
          return acc + customers.reduce((cAcc, kol) => cAcc + (parseFloat(row[`K${kol.CustCode}`]) || 0), 0);
        }, 0);
        if (visibleItems.length > 0) {
          footTotalCell.value = {
            formula: `SUM(${totalColLetter}${dataStartRow}:${totalColLetter}${footerRowNumber - 1})`,
            result: grandTotal
          };
        } else {
          footTotalCell.value = grandTotal;
        }
        footTotalCell.font = successHeaderFont;
        footTotalCell.fill = successHeaderFill;
        footTotalCell.numFmt = "#,##0";
        footTotalCell.alignment = { vertical: "middle", horizontal: "right" };
        footTotalCell.border = doubleBottomBorder;

        // Auto-fit Column Widths
        worksheet.getColumn(1).width = 38;
        customers.forEach((kol, kIdx) => {
          const colLen = (kol.CustName || "").length;
          worksheet.getColumn(2 + kIdx).width = Math.max(12, Math.min(28, colLen + 3));
        });
        worksheet.getColumn(totalColIndex).width = 20;

        // Generate buffer and trigger browser download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        const dateStr = this.model.orderdate ? moment(this.model.orderdate).format("YYYYMMDD") : moment().format("YYYYMMDD");
        link.href = url;
        link.setAttribute("download", `Bread_Request_Form_${dateStr}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.isLoading = false;
        toastr.success("Export XLSX berhasil diunduh.", "SUCCESS");
      } catch (error) {
        this.isLoading = false;
        toastr.error(error.message || "Gagal export ke XLSX", "ERROR MESSAGE");
      }
    }
  },
};
</script>
